<template>
  <div
    data-qa="club_price_pretty_details"
    class="club-price-pretty-details d-flex flex-column gr-1"
  >
    <div>
      <div
        class="text-h6 text--text"
        data-qa="club_price_pretty_details_online_price"
      >
        {{ priceList.online }}
      </div>
      <div
        class="text-h6 text-secondary--text"
        data-qa="club_price_pretty_details_lpu_price"
      >
        {{ priceList.lpu }}
      </div>
    </div>

    <div>
      <div class="text-body-2 text-secondary--text">
        Опцион на скидку
        <div
          v-if="isNoCard && cardPrice"
          data-qa="club_price_pretty_details_with_card_text"
        >
          + доступ к клубу
        </div>
      </div>
      <div class="text-body-2 text-secondary--text">
        Оплата приёма
      </div>
    </div>

    <div class="mt-1">
      <div class="py-1 bg-club-gradient rounded-sm" />
      <div class="py-1 bg-club rounded-sm" />
    </div>

    <div>
      <div class="text-body-2 text-warning--text">
        Покупка онлайн
      </div>
      <div class="text-body-2 text-secondary--text">
        В клинике
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { getFormattedPrice } from 'www/utils'

const props = defineProps<{
  lpuPrice?: number | null
  optionPrice?: number | null
  cardPrice?: number | null
  isNoCard: boolean
}>()

const priceList = computed(() => ({
  lpu: getFormattedPrice(props.lpuPrice),
  online: getFormattedPrice((props.optionPrice ?? 0) + (props.cardPrice ?? 0)),
}))
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.bg-club-gradient {
  background-image: $ui-kit-club-gradient;
}

.club-price-pretty-details {
  & > * {
    display: flex;
    column-gap: 12px;
    width: 100%;

    & > * {
      flex-grow: 1;
      width: 0;
    }
  }
}
</style>
